module.exports = __webpack_public_path__ + "img/icon-white-38.4c16aa4b.svg";